// @ts-check

import React from 'react';
import { string } from 'prop-types';
import TextField from '@mui/material/TextField';

/**
 * @component ProfileTextField
 * @param {Object} props
 * @param {string} props.label
 * @param {string} props.value
 * @returns {JSX.Element}
 */
function ProfileTextField({ label, value }) {
	return (
		<TextField
			label={label}
			color="primary"
			size="small"
			fullWidth
			variant="outlined"
			InputLabelProps={{ shrink: true }}
			value={value}
			sx={{
				'& fieldset': { border: 'none' },
				'& .MuiInputLabel-root': { color: 'var(--cl-paper-text-main)' },
			}}
			InputProps={{ readOnly: true }}
		/>
	);
}

ProfileTextField.propTypes = { label: string, value: string };

export default ProfileTextField;
